import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const filters = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
    reducerPath: 'api.filters',
    tagTypes: ['filters'],
    endpoints: (builder) => ({
        platforms: builder.query<any, {
            workspace: any
        }>({
            query: ({ workspace }) => {
                const url = `/filters/platforms`;
                const body = {
                    workspace
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        countries: builder.query<any, {
            workspace: any,
            platforms: any,
            startDate: any,
            endDate: any
        }>({
            query: ({ workspace, platforms, startDate, endDate }) => {
                const url = `/filters/countries`;
                const body = {
                    workspace,
                    platforms,
                    startDate,
                    endDate
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
        searchTerms: builder.query<any, {
            workspace: any,
            platforms: any,
            devices: any,
            startDate: any,
            countries: any
            endDate: any
        }>({
            query: ({ workspace, platforms, startDate, endDate, devices, countries }) => {
                const url = `/filters/search-terms`;
                const body = {
                    workspace,
                    platforms,
                    devices,
                    startDate,
                    endDate,
                    countries
                };

                return {
                    url,
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache',
                        Accept: 'application/json',
                    },
                };
            },
        }),
    }),
});

export const {
    usePlatformsQuery,
    useCountriesQuery,
    useSearchTermsQuery
} = filters;

export default filters;
